import { Component, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
import { Globals } from '../../../globals';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { CartService } from '../../../services/apicart/cart.service';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
    public menu = [];
    public length: number
    public top: number;
    public width: number;
    public control: boolean = false;
    public selected: any = { 'name': '' };
    public statusLogin: boolean;
    public infoUser: any;
    public data: any;
    public connect;
    public token: any = {
        getlistProduct: 'api/getlistProduct',
        getMenu: "api/getmenu",
        getcontent: "api/getlistcontent",
    }
    constructor(
        public translate: TranslateService,
        public cartApi: CartService,
        public router: Router,
        public globals: Globals,
    ) {
        this.connect = this.globals.result.subscribe((response: any) => {
            switch (response.token) {

                case "getmenu":
                    let data = this.compaid(response['data']);
                    this.menu = data;
                    this.length = +this.menu.length

                    break;
                case "getlistProduct":
                    //this.data = response.data;
                    break;
                case "getcontent":
                    this.data = response.data;
                    break;
                default:
                    break;
            }
        })
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.infoUser = this.globals.CUSTOMER.get(true);
                this.statusLogin = this.globals.CUSTOMER.check(true);
                let route = event.url;
                this.control = (route == '/' || route == '/trang-chu' || route == '/lien-he') ? true : false;
            }
        })
        this.width = document.body.getBoundingClientRect().width

    }
    ngOnInit() {
        this.getMenu();
        this.getProducts();
        this.globals.send({ path: this.token.getcontent, token: "getcontent" });

    }
    ngOnDestroy() {
        this.connect.unsubscribe();
    }
  
    onSelect(event: TypeaheadMatch): void {
        let item = event.item;
        this.selected.name = "";
        this.router.navigate(['/tin-tuc/' + item.parent_link + '/' + item.link]);
    }
    getProducts() {
        this.globals.send({ path: this.token.getlistProduct, token: "getlistProduct" });
    }
    getMenu() {
        this.globals.send({ path: this.token.getMenu, token: "getmenu", params: { position: 'menu' } });

    }
    compaid(data) {
        let list = [];
        data = data.filter(function (item) {
            let v = (isNaN(+item.parent_id) && item.parent_id) ? 0 : +item.parent_id;
            v == 0 ? '' : list.push(item);
            return v == 0 ? true : false;
        })
        let compaidmenu = (data, skip) => {
            if (skip == true) {
                return data;
            } else {
                for (let i = 0; i < data.length; i++) {
                    let obj = [];
                    list = list.filter(item => {

                        let skip = (+item.parent_id == +data[i]['id']) ? false : true;
                        if (skip == false) { obj.push(item); }
                        return skip;
                    })
                    let skip = (obj.length == 0) ? true : false;
                    data[i]['href'] = getType(data[i]['link'], +data[i].type);
                    data[i]['data'] = compaidmenu(obj, skip);
                }
                return data;
            }
        };
        let getType = (link, type) => {
            if (type == 3 && link == 'san-pham') {
                return 'san-pham';
            }
            if (type == 3) {
                return 'san-pham/' + link;
            }
            if (type == 4 && link != "tin-tuc") {
                return 'tin-tuc/' + link
            }
            return link
        }
        return compaidmenu(data, false);
    }
    logout() {
        this.globals.CUSTOMER.remove();
        setTimeout(() => {
            this.router.navigate(['/']);
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./src/app/frontend/modules/header/header.component.ts